export default __webpack_public_path__ + "0898ff22c7b14af05897e613215b1de0.png";